import {combineReducers} from "@reduxjs/toolkit";
import {reviewReducer} from "../review/review.slice";
import {cardsReducer} from "../cards/cards.slice";
import {cardEditorReducer} from "../cards/editor/cardEditor.slice";
import {addCardReducer} from "../cards/add/addCard.slice";
import {authReducer} from "../auth/auth.slice";
import {searchReducer} from "../cards/search/search.slice";
import {cardViewReducer} from "../cards/view/cardView.slice";
import { uiReducer } from "../ui/ui.slice";
import memorizeReducer from "../memorize/memorize.slice";
import { quickAddReducer } from "../cards/quickAdd/quickAdd.slice";

export const rootReducer = combineReducers({
    auth: authReducer,
    addCard: addCardReducer,
    cardEditor: cardEditorReducer,
    cards: cardsReducer,
    cardView: cardViewReducer,
    review: reviewReducer,
    search: searchReducer,
    ui: uiReducer,
    memorize: memorizeReducer,
    quickAdd: quickAddReducer,
});

export type RootState = ReturnType<typeof rootReducer>
